import { cloneDeep, orderBy } from "lodash-es";
import { PlaceList, PlaceListEntry } from "../../../models";
import { DataProviderArgs } from "../../DataStore/DataProvider";
import { Kernel } from "../../Kernel";
import { awsToSimpleObject } from "../../models/Models";
import { IPlaceList, IPlaceListEntry, IPlaceListTable } from "../IPlaceListTable";
import { DataStoreTable } from "./DataStoreTable";
import { DataStore } from "aws-amplify/datastore";
import { PlaceListEntryTable } from "./PlaceListEntryTable";

export class PlaceListTable extends DataStoreTable<IPlaceList> implements IPlaceListTable {
    constructor(
        args: DataProviderArgs,
        private _placeListEntryTable: PlaceListEntryTable
    ) {
        super(
            args,
            "place-list",
            PlaceList,
            (obj: any) => awsToSimpleObject(obj),
            (obj: any) => new PlaceList(obj)
        );
    }

    //-------------------------------------------------------------------------
    // Entries
    //-------------------------------------------------------------------------

    public async getEntries(placeId: string): Promise<IPlaceListEntry[]> {
        const list = await DataStore.query(PlaceList, placeId);
        if (list) {
            const reports = (await list.entries.toArray()).map((x: PlaceListEntry) =>
                awsToSimpleObject(x)
            );
            return orderBy(reports, "lastModified", "desc");
        }

        return [];
    }

    public async createEntry(listId: string, entry: IPlaceListEntry): Promise<IPlaceListEntry> {
        const awsObject: any = Object.assign(cloneDeep(entry), {
            owner: Kernel.instance().user?.id,
            placeList: await DataStore.query(PlaceList, listId),
        });

        return awsToSimpleObject(await DataStore.save(new PlaceListEntry(awsObject)));
    }

    public async deleteEntry(id: string) {
        return await this._placeListEntryTable.delete(id);
    }

    public async updateEntry(item: IPlaceListEntry) {
        return await this._placeListEntryTable.update(item);
    }
}
